import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Package, Briefcase, Percent, TrendingUp } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminHome() {
  const [stats, setStats] = useState({
    products: 0,
    portfolio: 0,
    discounts: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [products, portfolio, discounts] = await Promise.all([
        axios.get(`${API}/products`),
        axios.get(`${API}/admin/portfolio`),
        axios.get(`${API}/admin/discount-codes`)
      ]);
      setStats({
        products: products.data.length,
        portfolio: portfolio.data.length,
        discounts: discounts.data.length
      });
    } catch (error) {
    }
  };

  const statCards = [
    { label: 'Products', value: stats.products, icon: Package, color: 'bg-blue-500', link: '/admin/dashboard/products' },
    { label: 'Portfolio Items', value: stats.portfolio, icon: Briefcase, color: 'bg-green-500', link: '/admin/dashboard/portfolio' },
    { label: 'Discount Codes', value: stats.discounts, icon: Percent, color: 'bg-purple-500', link: '/admin/dashboard/discounts' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Welcome to Admin Panel</h2>
        <p className="text-gray-400">Manage your products, portfolio, and promotions from here.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {statCards.map((stat) => (
          <Link
            key={stat.label}
            to={stat.link}
            className="bg-gray-800 rounded-xl p-6 border border-gray-700 hover:border-gray-600 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-400 text-sm">{stat.label}</p>
                <p className="text-3xl font-bold text-white mt-1">{stat.value}</p>
              </div>
              <div className={`${stat.color} p-3 rounded-lg`}>
                <stat.icon className="w-6 h-6 text-white" />
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
        <h3 className="text-lg font-semibold text-white mb-4">Quick Actions</h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Link
            to="/admin/dashboard/products"
            className="bg-gray-700 hover:bg-gray-600 rounded-lg p-4 text-center transition-colors"
          >
            <Package className="w-8 h-8 text-[#F54021] mx-auto mb-2" />
            <span className="text-white">Add Product</span>
          </Link>
          <Link
            to="/admin/dashboard/portfolio"
            className="bg-gray-700 hover:bg-gray-600 rounded-lg p-4 text-center transition-colors"
          >
            <Briefcase className="w-8 h-8 text-green-500 mx-auto mb-2" />
            <span className="text-white">Edit Portfolio</span>
          </Link>
          <Link
            to="/admin/dashboard/discounts"
            className="bg-gray-700 hover:bg-gray-600 rounded-lg p-4 text-center transition-colors"
          >
            <Percent className="w-8 h-8 text-purple-500 mx-auto mb-2" />
            <span className="text-white">Create Discount</span>
          </Link>
          <Link
            to="/admin/dashboard/settings"
            className="bg-gray-700 hover:bg-gray-600 rounded-lg p-4 text-center transition-colors"
          >
            <TrendingUp className="w-8 h-8 text-yellow-500 mx-auto mb-2" />
            <span className="text-white">Settings</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
